import { LeadFormField, LeadFormFieldOptions } from '../../types/LeadForm'

export interface FieldDependencyRule {
  whenOptionId: string
  allowOptionIds: string[]
}

export interface FieldDependency {
  on: string
  rules: FieldDependencyRule[]
}

export interface EffectiveField {
  options: LeadFormFieldOptions[]
}

export const getFieldDependency = (
  field: LeadFormField
): FieldDependency | null => {
  const dependency = field.config?.dependency

  if (
    !dependency ||
    typeof dependency !== 'object' ||
    typeof dependency.on !== 'string' ||
    !dependency.on ||
    !Array.isArray(dependency.rules)
  ) {
    return null
  }

  const rules = dependency.rules.filter(
    (r: any) =>
      r &&
      typeof r === 'object' &&
      typeof r.whenOptionId === 'string' &&
      Array.isArray(r.allowOptionIds)
  )

  return { on: dependency.on, rules }
}

export const getEffectiveField = (
  field: LeadFormField,
  controllingValue: unknown
): EffectiveField => {
  const unrestricted: EffectiveField = {
    options: field.options
  }

  const dependency = getFieldDependency(field)

  if (!dependency) {
    return unrestricted
  }

  const selectedIds = Array.isArray(controllingValue)
    ? controllingValue.map((v) => String(v))
    : controllingValue
      ? [String(controllingValue)]
      : []

  const matchedRules = dependency.rules.filter((r) =>
    selectedIds.includes(String(r.whenOptionId))
  )

  if (!matchedRules.length) {
    return unrestricted
  }

  const allowIds = new Set<string>()
  for (const rule of matchedRules) {
    for (const id of rule.allowOptionIds) {
      allowIds.add(String(id))
    }
  }

  const allowed = field.options.filter((o) => allowIds.has(String(o._id)))

  if (!allowed.length) {
    return unrestricted
  }

  return { options: allowed }
}
